// ANGULAR
import { Injectable } from '@angular/core';

// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

// RXJS
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';

// SERVICES
import { ScheduleService } from '../services/schedule.service';

// ACTIONS AND STATES
import * as globalActions from '../../../global/store/actions';
import { State } from '../../../root-state';
import * as scheduleActions from './actions';

// COMMON INTERFACES AND ENUMS
import { ModalType } from '../../../../models/common/modal/modal-config';

// CONSTANT
import {  SCHEDULE_NGRX_CONSTANTS } from '../../../../constants/ngrx-store/schedule';


/**
 * This effect is for listen schedule actions, execute schedule service call and dispatch in schedule reducer.
 * For schedule api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 28-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created schedule effect
 */
@Injectable()
export class ScheduleEffects {
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private scheduleService: ScheduleService) { }

    /**
			* Schedule Effect
			* @param type : Schedule action name.
			* @param payload : object to identify common schedule method base on module and method.
			* @returns Empty action dispatch to reducer.
			*/
  scheduleCommonEffect$ = createEffect(() => this.actions$.pipe(
    ofType<scheduleActions.ScheduleCommonAction>(scheduleActions.ActionTypes.SCHEDULE_COMMON),
    withLatestFrom(this.store),
    mergeMap(([action, state]): Observable<any> => {
      // get common constant base action module and method.
      // changed to payload type from payload.data.method
      const common = SCHEDULE_NGRX_CONSTANTS[action.payload.module][action.payload.method];

      // Per-state-key cache short-circuit removed: it caches PER STATE KEY
      // (not per payload), so any re-fetch on the same method (Reset, filter,
      // date-range change, refresh, copy/repeat/publish-after-flow) was
      // silently dropped and the host component's `loading` flag stayed
      // `true`. Components own their refetch policy.

      return this.scheduleService[common.API_METHOD](action.payload.data)
        .pipe(

          mergeMap((data: any) => {
            // throwing an error on if the status is not 200
            let actions: any[] = [];


            // dispatch schedule success action
            actions = [new scheduleActions.ScheduleCommonSuccessAction({ data, common })];

            if (common.SUCCESS_NOTIFICATION) {
              if (data && data.status !== 200) {
                // { ...data, success: data.type === ModalType.SUCCESS }
                action.payload.callback && action.payload.callback( { response: data, success: data.type === ModalType.SUCCESS });
               } else {
                   // dispatch popup notification for open success popup
              actions.push(new globalActions.PopupNotificationAction({
                actionType: scheduleActions.ActionTypes.SCHEDULE_COMMON, type: ModalType.SUCCESS,
                callback: action.payload.callback, title: common.TITLE, message: common.SUCCESS,
                code: `${common.SUCCESS}`, response: data,
              }));
               }
            } else {
              action.payload.callback && action.payload.callback({ success: true, data });
            }

            return actions;
          }),
          catchError(error => {
            // dispatch popup notification for open error popup
            return of(new globalActions.PopupNotificationAction({
              actionType: scheduleActions.ActionTypes.SCHEDULE_COMMON_SUCCESS, type: ModalType.ERROR,
              message: error && error.error && error.error.message, callback: action.payload.callback, error: (error || error.error),
              // code: `ERROR.${error.code || error.error.code}`,
              title: common.TITLE,
            }));
          },
          ));
    }),
  ));

}
